import React from 'react';
import { Typography } from '@mui/material';

const Blog = () => {
  return (
    <div>
      <Typography variant="h4" gutterBottom>Blog</Typography>
      <Typography variant="body1">
        Articles will appear here...
      </Typography>
    </div>
  );
};

export default Blog;
